import "./StoryDetail.css";

import React, { useRef, useState } from "react";
import {
  epochToDateString,
  getAuthorImage,
  getAuthorName,
  getRandomColor,
} from "../../helper";

import { useFetchStoryDetails } from "../../hooks/APIs/useFetchStoryDetails";

const StoryDetail: React.FC = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");

  const { storyDetails } = useFetchStoryDetails();

  const handleSubscription = () => {
    console.log(`Subscribed with: ${firstName} ${lastName}, ${email}`);
  };

  const profileIconRef = useRef<HTMLDivElement | null>(null);
  const userName = storyDetails
    ? getAuthorName(storyDetails) || storyDetails.email || ""
    : "";
  const firstLetter = userName.charAt(0).toUpperCase();

  const avatarColor = getRandomColor(firstLetter);

  const storyDate = storyDetails?.createdAt
    ? epochToDateString(storyDetails.createdAt._seconds)
    : "";

  const imageURL = storyDetails ? getAuthorImage(storyDetails) : undefined;

  return (
    <div className="main-sroty-detail">
      {!!storyDetails && (
        <div className="story-detail-container">
          <div className="story-main-content">
            <div>
              <div className="story-detail-heading">
                {storyDetails?.heading || ""}
              </div>
              <div className="story-detail-sub-heading">
                {storyDetails?.subHeading || ""}
              </div>
            </div>

            <div className="story-content">
              <div className="profile">
                {imageURL ? (
                  <img
                    ref={profileIconRef}
                    src={imageURL}
                    alt="Profile"
                    className="profile-icon"
                  />
                ) : (
                  <div
                    ref={profileIconRef}
                    className="profile-icon"
                    style={{ backgroundColor: avatarColor }}
                  >
                    {firstLetter}
                  </div>
                )}

                <div className="profile-details">
                  <div className="profile-name">{userName}</div>
                  <div className="story-detail-profile-time">
                    {storyDate}{" "}
                    {storyDetails?.topic.map((topic) => topic + " ")}
                  </div>
                </div>
              </div>

              <hr className="divider" />

              <div
                className="story-text"
                dangerouslySetInnerHTML={{
                  __html: storyDetails?.content || "",
                }}
              />

              <div className="notification-section">
                <img src="/assets/Bell.png" alt="Bell" className="bell-icon" />
                <div className="notification-text">
                  Get Notified for New Columns Published
                </div>
                <div className="small-text">
                  If you would like us to notify you when a new column appears,
                  please fill out this form.
                </div>

                <div className="input-row">
                  <div>
                    {/* <label htmlFor='firstName' className='input-label'>
                  First Name
                </label> */}
                  </div>
                  <input
                    type="text"
                    className="input-field"
                    placeholder="First Name"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                  <div style={{ margin: "0px" }}>
                    {/* <label htmlFor='lastName' className='input-label'>
                  Last Name
                </label> */}
                  </div>
                  <input
                    type="text"
                    className="input-field"
                    placeholder="Last Name"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </div>

                <div>
                  {/* <label htmlFor='email' className='input-label'>
                Email
              </label> */}
                </div>
                <div className="centered-input">
                  <input
                    type="email"
                    className="input-field"
                    placeholder="Email Address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <button
                    className="subscribe-btn"
                    onClick={handleSubscription}
                  >
                    Subscribe for Free
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StoryDetail;
